import { Component, Mixins, Prop } from 'vue-property-decorator';

import NameRow from '@/forms/FormElements/Rows/NameRow/NameRow.vue';
import PhoneRow from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.vue';
import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import ButtonsRow from '@/forms/FormElements/Rows/ButtonsRow/ButtonsRow.vue';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';
import MessageRow from '@/forms/FormElements/Rows/MessageRow/MessageRow.vue';
import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import CheckBoxRow from '@/forms/FormElements/Rows/CheckBoxRow/CheckBoxRow.vue';
import DropdownRow from '@/forms/FormElements/Rows/DropdownRow/DropdownRow.vue';

import SelectItem from '@/common/interfaces/SelectItem';

import { ChartersRequestModel, names } from './ChartersRequestForm.types';
import Message from '@/forms/Validations/Message';
import getValidation from '@/modules/ChartersRequestModule/ChartersRequestForm/ChartersRequestForm.validations';

import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';
import { CleaveOptions } from 'cleave.js/options';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  components: {
    NameRow,
    PhoneRow,
    EmailRow,
    MessageRow,
    TextRow,
    ButtonsRow,
    CheckBoxRow,
    ButtonRow,
    DropdownRow,
  },
})
export default class ChartersRequestForm extends Mixins(FormValidationMixin) {
  names = names;
  
  model: ChartersRequestModel = model;

  @Prop()
  readonly NumberOfGuestsOptions!: SelectItem[];

  @Prop()
  readonly ExpectedTravelDateOptions!: SelectItem[];
  
  @Prop()
  readonly TypeId!: number;

  expectedTravelDateMonthOptions: SelectItem[] = [
    { Text: 'January', Value: 'January' },
    { Text: 'February', Value: 'February' },
    { Text: 'March', Value: 'March' },
    { Text: 'April', Value: 'April' },
    { Text: 'May', Value: 'May' },
    { Text: 'June', Value: 'June' },
    { Text: 'July', Value: 'July' },
    { Text: 'August', Value: 'August' },
    { Text: 'September', Value: 'September' },
    { Text: 'October', Value: 'October' },
    { Text: 'November', Value: 'November' },
    { Text: 'December', Value: 'December' },
  ]

  expectedTravelDateYearOptions = []

  mounted() {
    const startYear = new Date().getFullYear() + 1
    const endYear = startYear + 6

    for (let i = 0; endYear - startYear !== i; i++) {
      let currentYear = startYear + i
      this.expectedTravelDateYearOptions.push({Text: currentYear, Value: currentYear})
    }
  }

  numberFormatter: CleaveOptions = {
    blocks: [3],
    numericOnly: true,
  };

  setTypeIdAndSubmit () {
    this.model.TypeId = this.TypeId;
    this.submit();
  }
  get getLable()
  {
    return this.TypeId === 1
    ? "Please tell us more about your charter group, goals, and interests." 
    : "Please tell us more about your desired destinations"
  }

  messages: Message[] = messages;  
}
